import { initSlimSelects } from "../libs/slimselect.utils";
import { initAjaxTables } from "./ajax-tables";

export function initContactsTable() {
  initSlimSelects();
}

export function initReferentsTable() {
  initSlimSelects();
  initAjaxTables();
}
